export default "__VITE_ASSET__DzYgkQyW__"